import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MergePurgeParameters } from './types/merge-purge-parameters.type';
import type { ModelingByList } from './types/modeling-by-list.type';

/**
 * Fetches modeling data by list for merge-purge reports.
 *
 * Sends a GET request to the `modelingByList` endpoint using the provided Ky instance and search parameters.
 * Returns an array of `ModelingByList` objects wrapped in an `OperationResultWithData`.
 *
 * @param instance - The Ky HTTP client instance to use for the request.
 * @param searchParams - The parameters to filter the modeling data.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link ModelingByList}.
 * @throws Will throw an error if the request fails.
 */
export const getModelingByList = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<ModelingByList[]>>(Uri.reports.mergePurge.modelingByList, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
